import {
  ApplePayMerchantCapabilities,
  ApplePaySupportedNetworks,
  GooglePayAuthMethods,
  GooglePayCardNetworks,
} from '@/common/models/groups'

const toEnumValues = <T extends Record<string, string>>(
  enumObj: T,
  items?: string[],
): string[] =>
  (items ?? []).map((item) => {
    if (Object.values(enumObj).includes(item)) {
      return item
    }

    return enumObj[item as keyof T] ?? item
  })

const toEnumKeys = <T extends Record<string, string>>(
  enumObj: T,
  items?: string[],
): string[] =>
  (items ?? []).map((item) => {
    if (item in enumObj) {
      return item
    }

    return (
      Object.entries(enumObj).find(([, value]) => value === item)?.[0] ?? item
    )
  })

export const mapApplePayConfigFromApi = (config: {
  supportedNetworks?: string[]
  merchantCapabilities?: string[]
}) => ({
  supportedNetworks: toEnumValues(
    ApplePaySupportedNetworks,
    config.supportedNetworks,
  ) as ApplePaySupportedNetworks[],
  merchantCapabilities: toEnumValues(
    ApplePayMerchantCapabilities,
    config.merchantCapabilities,
  ) as ApplePayMerchantCapabilities[],
})

export const mapApplePayConfigToApi = (config: {
  supportedNetworks?: ApplePaySupportedNetworks[]
  merchantCapabilities?: ApplePayMerchantCapabilities[]
}): {
  supportedNetworks: ApplePaySupportedNetworks[]
  merchantCapabilities: ApplePayMerchantCapabilities[]
} => ({
  supportedNetworks: toEnumKeys(
    ApplePaySupportedNetworks,
    config.supportedNetworks,
  ) as ApplePaySupportedNetworks[],
  merchantCapabilities: toEnumKeys(
    ApplePayMerchantCapabilities,
    config.merchantCapabilities,
  ) as ApplePayMerchantCapabilities[],
})

export const mapGooglePayConfigFromApi = (config: {
  cardNetworks?: string[]
  authMethods?: string[]
}) => ({
  cardNetworks: toEnumValues(
    GooglePayCardNetworks,
    config.cardNetworks,
  ) as GooglePayCardNetworks[],
  authMethods: toEnumValues(
    GooglePayAuthMethods,
    config.authMethods,
  ) as GooglePayAuthMethods[],
})

export const mapGooglePayConfigToApi = (config: {
  cardNetworks?: GooglePayCardNetworks[]
  authMethods?: GooglePayAuthMethods[]
}): {
  cardNetworks: GooglePayCardNetworks[]
  authMethods: GooglePayAuthMethods[]
} => ({
  cardNetworks: toEnumKeys(
    GooglePayCardNetworks,
    config.cardNetworks,
  ) as GooglePayCardNetworks[],
  authMethods: toEnumKeys(
    GooglePayAuthMethods,
    config.authMethods,
  ) as GooglePayAuthMethods[],
})
